import React, { useMemo } from 'react';
import { IPost } from '../../custom-types';
import PostCard from './PostCard';

function PostRelatedArticles({ posts, currentPostId }: { posts: IPost[]; currentPostId: string }) {
  const blogPostsList = () => {
    let list = posts?.sort(function (a, b) {
      const publicationDate1 = a?.publish_at ?? a?.publishedAt;
      const publicationDate2 = b?.publish_at ?? b?.publishedAt;
      const date1 = new Date(publicationDate1);
      const date2 = new Date(publicationDate2);
      return date2?.getTime() - date1?.getTime();
    });
    list = list?.filter(function (obj) {
      return obj.id !== currentPostId;
    });

    list = list?.slice(0, 6)?.map((post) => post);
    return list?.map((blogPost: IPost) => <PostCard key={blogPost?.id} post={blogPost} showBadge={false} />);
  };

  return (
    <div className="w-full overflow-auto">
      <div className="w-full flex">
        <div className="flex flex-col lg:flex-row lg:flex-wrap">{blogPostsList()}</div>
      </div>
    </div>
  );
}

export default PostRelatedArticles;
